import * as z from 'zod';

import { emailsLinkerMutationSchema } from '@/_containers/inputs/emails/shared/schema';
import { nullableNumericMutationSchema } from '@/_schemas/generic';

import { contactQuerySchema } from './contact-query-schema';

export const contactUpdateSchema = contactQuerySchema
  .omit({
    profile_image: true,
    friends: true,
    status: true,
    work_anniversary: true,
    wedding_anniversary: true,
    phone_numbers: true,
    interests: true,
    username: true,
    birth_day: true,
    birth_month: true,
    registration_date: true,
    addresses: true,
    clients: true,
    primary_client: true,
    alternate_clients: true,
    emails: true,
    agreements: true,
    marketing_campaigns: true,
  })
  .extend({
    status: z.string(),
    birth_day: z.number().nullable(),
    birth_month: z.number().nullable(),
    work_anniversary: z.string().nullable(),
    wedding_anniversary: z.string().nullable(),
    interests: z.string().nullable(),
    remote_worker: z.number(),
    phone_numbers: z.array(z.number()),
    addresses: z.array(z.number()),
    profile_image: z.array(z.number()),
    contacts_associated_with: z.array(z.number()),
    primary_client: z.array(z.number()),
    alternate_clients: z.array(z.number()),
    emails: emailsLinkerMutationSchema,

    freshdesk: nullableNumericMutationSchema(),
  });

export type ContactUpdateSchema = z.infer<typeof contactUpdateSchema>;

export const contactCreateSchema = contactUpdateSchema.pick({
  first_name: true,
  last_name: true,
  status: true,
  email: true,
  title: true,
  birth_day: true,
  birth_month: true,
  linked_in_url: true,
  twitter_handle: true,
});

export type ContactCreateSchema = z.infer<typeof contactCreateSchema>;
